<template>
  <div class="wheel-inner-container">
    <div class="pointer">
      <div></div>
    </div>
    <FortuneWheel
      :canvas="canvasOptions"
      :prizes="prizes"
      :useWeight="true"
      ref="fortunewheel"
      @rotateStart="onCanvasRotateStart"
      @rotateEnd="onRotateEnd"
    />
  </div>
</template>

<script>
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import FortuneWheel from "vue-fortune-wheel";
  import confetti from "canvas-confetti";

  @Component({
    components: {
      FortuneWheel
    }
  })
  class Spinner extends Vue {
    @Prop({ type: Array, required: true }) prizes;

    canvasOptions = {
      borderColor: "white",
      borderWidth: 10,
      btnText: "⟳",
      imageSize: 80,
      fontSize: 28,
      textDirection: "vertical",
      textLength: 13,
      textRadius: 220
    };

    onCanvasRotateStart() {
      // console.log("started rotating!");
    }

    onRotateEnd(prize) {
      confetti({
        particleCount: 500,
        spread: 180,
        ticks: 1000,
        disableForReducedMotion: true
      });
      // alert(prize.value);
      // console.log("Het wiel is gestopt bij....." + prize.value);
    }

    @Watch("prizes", { deep: true })
    redrawCanvas() {
      this.$refs.fortunewheel.drawCanvas();
    }
  }
  export default Spinner;
</script>

<style lang="scss" scoped>
$wheel-size: 500px;
$max-wheel-size: 90vw;

.fw-container::v-deep {
  position: relative;
  width: $wheel-size;
  height: calc(#{$wheel-size} + 55px);
  max-width: calc(#{$max-wheel-size} + 1px);
  max-height: calc(#{$max-wheel-size} + 1px);
  overflow: hidden;
  aspect-ratio: 1/1;

  .fw-wheel,
  canvas {
    width: $wheel-size;
    height: $wheel-size;
    max-width: $max-wheel-size;
    max-height: $max-wheel-size;
    aspect-ratio: 1/1;
  }

  .fw-btn {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: flex-end;

    .fw-btn__btn {
      font-family: sans-serif;
      color: #EA5503;
      background: white;
      border-radius: 25px;
      text-align: center;
      height: 35px !important;
      width: 45px !important;
      font-size: 21px;
      padding-top: 10px;
      cursor: default;
      -webkit-text-stroke: 0.75px #EA5503;

      &:after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
      }
    }
  }
}

.wheel-inner-container {
  position: relative;

  .pointer {
    position: absolute;
    top: 8px;
    width: 100%;
    z-index: 1;
    pointer-events: none;

    div {
      width: 0;
      height: 0;
      margin: auto;
      border-color: white transparent transparent transparent;
      border-style: solid;
      border-width: 1.5rem 0.5rem 0 0.5rem;
    }
  }
}
</style>
